import { combineReducers } from 'redux'; 

import { PlayQuiz, Question, Cookie, Language, ServerResponse, Timer, UiFeedback } from './reducerLogic.js';

export default combineReducers({ PlayQuiz, Question, Cookie, Language, ServerResponse, Timer, UiFeedback }); //name for state object in store